import moment from 'moment';
import * as _ from 'underscore';
import * as Utils from '../../../../lib/designerUtils';
import ACTIONS from '../actions';

const nutrition = (state = {}, action) => {
    switch (action.type) {
        case ACTIONS.NUTRITION_LOAD:
            const nutritionByDate = { ...state };
            for (let i = 0; i < action.nutrition.length; i++) {
                const dailyNutrition = action.nutrition[i];
                const dateKey = Utils.getDayKey(moment(dailyNutrition.date));
                nutritionByDate[dateKey] = dailyNutrition;
            }
            return nutritionByDate;
        case ACTIONS.NUTRITION_CLEAR:
            return {};
        default:
            return state;
    }
};

export default nutrition;
